import { Directive, HostListener } from '@angular/core';
import { timer } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmDiscardUnsavedChangesContentComponent } from '../modal-confirm/confirm-discard-unsaved-changes-content/confirm-discard-unsaved-changes-content.component';

@Directive({
    selector: '[sessionTimeout]'
})
export class SessionTimeoutDirective {
    constructor(
        private modalService: NgbModal
    ) {
        this.counter = 0;
        this.isPopupActive = true;
        //this.startTimer();
    }
    timeLeft: number = 10;
    interval;

    /*
    subscribeTimer: any;

    oberservableTimer() {
        const source = timer(1000, 2000);
        const abc = source.subscribe(val => {
            console.log(val, '-');
            this.subscribeTimer = this.timeLeft - val;
        });
    }*/

    private isPopupActive: boolean;

    startTimer() {
        this.interval = setInterval(() => {
            if (this.timeLeft > 0) {
                this.timeLeft--;
            } else {
                const modalRef = this.modalService.open(ConfirmDiscardUnsavedChangesContentComponent, {
                    backdrop: 'static',
                    size: 'sm',
                });
                this.timeLeft = 10;
            }
            // console.log(this.timeLeft);
        }, 1000);
    }

    pauseTimer() {
        clearInterval(this.interval);
    }

    private counter: number;
    @HostListener('click', ['$event'])
    onClick($event) {
        this.counter++;

        this.timeLeft = 60;
    }
    @HostListener('window:keydown', ['$event'])
    handleKeyDown($event) {
        this.counter++;

        this.timeLeft = 60;
    }
}
